<template>
  <div>
    <div v-show="notMobile" class="customerService">
      <a href="mailto:himo.industry@haier.com"
        ><i
          class="el-icon-message mail-hover"
          style="font-size: 30px; color: #979797; padding: 5px 0"
        ></i
      ></a>
      <el-tooltip
        popper-class="tooltip"
        content="Online Service"
        placement="left"
      >
        <div
          :class="!blink ? 'icon' : 'icon-blink'"
          @click="showChatWindow"
          @mouseover="talkActive = true"
          @mouseleave="talkActive = false"
        >
          <img :src="talkActive ? talkActiveIco : talkIco" />
        </div>
      </el-tooltip>

      <el-tooltip
        popper-class="tooltip"
        content="Hotline : +86 21-6769-6068 / +86 133-4129-3141 / +86 400-135-7277"
        placement="left"
      >
        <div
          class="icon"
          @mouseover="phoneActive = true"
          @mouseleave="phoneActive = false"
        >
          <img :src="phoneActive ? phoneActiveIco : phoneIco" />
        </div>
      </el-tooltip>
      <div
        class="icon"
        @mouseover="topActive = true"
        @mouseleave="topActive = false"
      >
        <img :src="topActive ? topActiveIco : topIco" @click="scrollToTop" />
      </div>
    </div>
    <ChatWindow ref="chatWindow" @newmessage="onNewMessage" />
  </div>
</template>
<script>
import "./_CustomerService.scss";
import ChatWindow from "./ChatWindow/ChatWindow";
import phoneIco from "./icon/phone.jpg";
import phoneActiveIco from "./icon/phone-active.jpg";
import talkIco from "./icon/talk.jpg";
import talkActiveIco from "./icon/talk-active.jpg";
import topIco from "./icon/top.jpg";
import topActiveIco from "./icon/top-active.jpg";

export default {
  name: "CustomerService",
  components: { ChatWindow },
  props: {},
  data() {
    return {
      mountChatWindow: false,
      dialogTableVisible: true,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      blink: false,
      formLabelWidth: "120px",
      talkActive: false,
      phoneActive: false,
      topActive: false,
      phoneIco,
      phoneActiveIco,
      talkIco,
      talkActiveIco,
      topIco,
      topActiveIco,
    };
  },
  computed: {
    notMobile() {
      return !this.$store.state.isMobile;
    },
  },
  methods: {
    showChatWindow() {
      // this.blink = false;
      // this.talkActive = false;
      // this.$store.commit("showCustomerService");
      xn("openChat", "kf_10024_template_21");
    },
    scrollToTop() {
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: "smooth",
      });
    },
    onNewMessage() {
      this.talkActive = true;
      this.blink = true;
    },
  },
};
</script>
